import { EtapaSituacao } from "../../enum/etapa-situacao.enum";
import { Contato } from "../contato/contato.model";
import { Etapa } from "../etapa/etapa-model";
import {Conta} from '../conta.model';
import {Usuario} from '../usuario/usuario.model';
import {IdNome} from '../id-nome.model';

export class Sessao {
  id?: number;
  tempoFinalizar?: number;
  dataFormatadaFinalizar?: string
  dataInicio?: Date;
  dataFim?: Date;
  dataUltimaMensagem?: Date;
  etapa?: Etapa;
  contato?: Contato
  ativo?: boolean;
  etapaSituacao?: EtapaSituacao;
  tempoEtapaAtual?: number;
  conta?: Conta;
  operador?: Usuario;
  operadorUuid?: string;
  operadorExtensaoImg?: string;
  fluxo?: IdNome;
  canal?: IdNome;
  tags?: string[];
}
